import { CssBaseline, Grid, ThemeProvider } from "@mui/material";
import "./App.css";
import Navbar from "./Navbar";
import About from "./Pages/About";
import Experience from "./Pages/Experience";
import Dashboard from "./Pages/Dashboard";
import Skills from "./Pages/Skills";
import Education from "./Pages/Education";
import Projects from "./Pages/Projects";
import Footer from "./Pages/Footer";
import CustomCursor from "./components/CustomCursor";
import PageLoader from "./components/PageLoader";
import { darkTheme, lightTheme } from "./common";
import { createContext, useState } from "react";

export const AppContext = createContext(null);

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const value = { darkMode, setDarkMode, loaded };

  return (
    <AppContext.Provider value={value}>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        {/* Subtle film-grain texture — adds tactile depth to both themes */}
        <div className="grain-layer" />
        <PageLoader onComplete={() => setLoaded(true)} />
        <CustomCursor />
        <Navbar />

        {/* Padded sections */}
        <Grid container px={5}>
          <Grid item xs={12}>
            <Dashboard />
            <About />
          </Grid>
        </Grid>

        {/* Experience: full-viewport-width — no outer padding so horizontal scroll works */}
        <Experience />

        {/* Padded sections */}
        <Grid container px={5}>
          <Grid item xs={12}>
            <Skills />
            <Education />
            <Projects />
          </Grid>
        </Grid>

        <Footer />
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
